import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MomentModule } from 'angular2-moment';

import { SharedModule } from '../shared/shared.module';
import { WeatherService } from './weather/weather.service';
import { MockWeatherService } from './weather/mock-weather.service';
import { MetarComponent } from './metar/metar.component';
import { FlightCategoryComponent } from './flight-category/flight-category.component';
import { WindComponent } from './wind/wind.component';
import { SkyConditionsComponent } from './sky-conditions/sky-conditions.component';
import { AppMaterialModule } from '../app-material.module';
import { WxIconComponent } from './wx-icon/wx-icon.component';
import { TafComponent } from './taf/taf.component';


@NgModule({
  imports: [
    CommonModule,
    MomentModule,
    SharedModule,
    AppMaterialModule
  ],
  exports: [
    WxIconComponent,
    MetarComponent,
    TafComponent
  ],
  declarations: [
    MetarComponent,
    FlightCategoryComponent,
    WindComponent,
    SkyConditionsComponent,
    WxIconComponent,
    TafComponent
  ],
  providers: [{
    provide: WeatherService,
    useClass: WeatherService    // Replace with MockWeatherService for testing with static sample data
  }]
})
export class WeatherModule { }
